import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2160c34e")
const _hoisted_1 = { class: "d-flex flex-column gap-4" }
const _hoisted_2 = { class: "bg-white card p-4 gap-4" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-column align-items-center bg-white card p-4 gap-4"
}
const _hoisted_4 = { class: "container d-flex flex-column h-100 rounded p-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "align-plus me-2" }, "+", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, " Add another plan ", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductSelect = _resolveComponent("ProductSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productGroups, (group) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: group }, [
          (!_ctx.doesOtherGroupHaveProductsInCart(group.groupName))
            ? (_openBlock(), _createBlock(_component_ProductSelect, {
                key: 0,
                marketingProperties: group.marketingAttributes,
                doesSelectionRequireItemSelection: 
            group.isDeviceModelSelectionRequired
          ,
                productGroupName: group.groupName,
                products: group.products
              }, null, 8, ["marketingProperties", "doesSelectionRequireItemSelection", "productGroupName", "products"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    (_ctx.areTheyProductsInCart)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addCurrentProductGroupInCard())),
              primary: "",
              class: "\n            px-25\n            py-1\n            btn btn-primary\n            inter\n            btn-mobile btn-compact\n            w-100-mobile\n            fw-600\n            ml-auto\n            align-items-center\n            fs-65\n          "
            }, _hoisted_7)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}